import * as types from '../mutation-types'
import api from '@/api/news'
import settingCompanyApi from '@/api/settingCompany'

// initial state
const state = {
    news: [],
    loaded: false,
    newsMetaInfo: {},
    newsCount: 0,
    newsCategories: [],
    newsCategoriesLoaded: [],
}

const getters = {
    news: state => state.news,
    newsLoaded: state => state.loaded,
    newsMetaInfo: state => state.newsMetaInfo,
    newsCount: state => state.newsCount,
    newsCategories: state => state.newsCategories,
    newsCategoriesLoaded: state => state.newsCategoriesLoaded
}

const actions = {
    getNews({ commit }, params) {
        commit(types.SET_NEWS_LOADED, false );
        api.getNews(params, (response) => {
            commit(types.SET_NEWS_META, response );
            commit(types.SET_NEWS_COUNT, response._total );
            commit(types.SET_NEWS, response._embedded.News );
            commit(types.SET_NEWS_LOADED, true );
        })
    },
    getNewsCategories({ commit }) {
        commit(types.SET_CATEGORY_NEWS_LOADED, false );
        settingCompanyApi.getSettingCompany({code: 'USENEWSCATEGORIES'}, (response) => {
            if(response._embedded.SettingCompany.length && response._embedded.SettingCompany[0].value === 'true') {
                settingCompanyApi.getSettingCompany({SettingType_code_idType_idSettingType: 'NEWSCATEGORIES'}, (response) => {
                    commit(types.SET_NEWS_CATEGORIES, response._embedded.SettingCompany );
                })
            } else {
                commit(types.SET_NEWS_CATEGORIES, [] );
            }
            commit(types.SET_CATEGORY_NEWS_LOADED, true );
        })
    },
    cleanNews({commit}) {
        commit(types.CLEAN_NEWS );
    }
}

const mutations = {
    [types.SET_NEWS] (state, news ) {
        state.news = [...state.news, ...news]
    },
    [types.CLEAN_NEWS] (state ) {
        state.news = []
    },
    [types.SET_NEWS_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_NEWS_META] (state, meta ) {
        state.newsMetaInfo = meta
    },
    [types.SET_NEWS_COUNT] (state, count ) {
        state.newsCount = count
    },
    [types.SET_NEWS_CATEGORIES] (state, categories ) {
        state.newsCategories = categories
    },
    [types.SET_CATEGORY_NEWS_LOADED] (state, status ) {
        state.newsCategoriesLoaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


